import { DateTime } from "luxon";

/**
 * Parses a date string into a Date object.
 * If the input is not a valid date string, it returns an "Invalid Date" object.
 *
 * This were necessary because the date-fns parseISO function does not handle invalid dates gracefully in new versions.
 * https://github.com/date-fns/date-fns/issues/3816
 *
 * To be able to handle time zones correctly, we use Luxon instead of the native Date object.
 *
 * @param {any} date - The date string to parse.
 * @returns {DateTime} - The parsed Date object or "Invalid Date".
 */
const parseISO = (date: any): DateTime => {
    const parsedDate = DateTime.fromISO(date, { setZone: true });
    return parsedDate;
};

export default parseISO;
